/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Internal_Only_Badge_TooltipInputs */



/**
* | output |
* | --- |
* | "This chat is restricted to your organisation's linked knowledge sources. Web search and external sources are disabled." |
*
* @param {Rag_Internal_Only_Badge_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_internal_only_badge_tooltip = /** @type {((inputs?: Rag_Internal_Only_Badge_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Internal_Only_Badge_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Chat ist auf die verlinkten Wissensquellen Ihrer Organisation beschränkt. Websuche und externe Quellen sind deaktiviert.")
	return /** @type {LocalizedString} */ ("This chat is restricted to your organisation's linked knowledge sources. Web search and external sources are disabled.")
});